import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import InnerBanner from "../../components/InnerBanner";

const PrivacyPolicy = () => {
  return (
    <>
      <InnerBanner title="Privacy Policy" />
      <section className="section-padding">
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col md={12}>
              <div className="section-heading">
                <h2>Privacy Policy</h2>
                <p>
                  We may collect your personal data that you provide to us, for
                  example, when you contact us electronically or respond to our
                  email. We may collect your business contact details when you
                  exchange business cards with our representatives at meetings
                  and events, or when you provide your contacts to sign up for
                  our events.
                </p>
                <p>
                  When submitting your request/inquiry on our websites, you may
                  be asked for information such as, but not limited to, your
                  full name, email address, phone number, company you work for
                  or own and/or country where you reside or work.
                </p>
                <p>
                  When contacting us through live chats on our websites, you may
                  be asked for information such as, but not limited to, your
                  name and email address. This is needed when we are not ready
                  to answer you immediately and need more time to handle your
                  request. When you give us your personal data in live chat, we
                  assume that you consent to processing it by Technocrom.
                </p>
                <p>
                  By using cookies, we may collect details of your visits to our
                  websites such as, but not limited to, the pages you visited,
                  the date, time and duration of your visit and/or your IP
                  address as well as the browser you use and its version, your
                  operating system and its version, your city and state.
                </p>
                <p>
                  It is our policy to collect only the minimum information
                  required to handle and complete your request/inquiry or to
                  reach other purposes for which we process your personal data.
                  If you believe our websites have collected excessive
                  information about you, please contact us through the
                  request/inquiry form to raise your concerns.
                </p>
                <p>
                  We do not intend to collect sensitive information through our
                  websites unless it is legally required to do so. Examples of
                  sensitive information include race or ethnic origin, political
                  opinions, religious or philosophical beliefs, trade union
                  membership, physical or mental health, genetic data, biometric
                  data, sexual life or sexual orientation, and criminal records.
                  We ask that you do not provide sensitive data of such nature
                  when using our websites.
                </p>
                <p>
                  When you submit your request/inquiry on our websites, we use
                  your data on the basis of your consent. In other cases, when
                  you voluntarily exchange business contact details with us, we
                  send you information or marketing communications on the basis
                  of our legitimate interests in maintaining a business
                  relationship with you or companies you work for or represent
                  and/or on the basis of your consent (when it is technically
                  possible to collect your freely given, specific, informed and
                  unambiguous consent). Cookies are used on the basis of your
                  consent and/or our legitimate interest described below.
                </p>

                <h2>Purposes for which we use your personal data</h2>
                <p>
                  We may use your data to interact with you and/or respond to
                  your requests/inquiries, to negotiate, perform or facilitate a
                  contract with you or related to you, to send you invitations
                  to events we organize, to share with you information you might
                  be interested in and/or to inform you about our services. We
                  may also use your personal data to comply with law,
                  regulations, public authority requests or court orders.
                </p>
                <p>
                  These are examples of purposes for which we may use personal
                  data you provide to us:
                </p>
                <ul>
                  <li>to administer and manage our websites;</li>
                  <li>
                    to understand how people use the features and functions of
                    our websites in order to improve user experience;
                  </li>
                  <li>
                    to determine the company, organisation, institution, or
                    agency that you work for or represent or with which you are
                    otherwise associated;
                  </li>
                  <li>to develop our businesses and services;</li>
                  <li>to analyze the usage of our websites;</li>
                  <li>
                    any other purposes for which you provided information to us.
                  </li>
                </ul>
                <p>
                  Our websites do not collect or compile personally identifying
                  information for sale to third parties for consumer marketing
                  purposes.
                </p>

                <h2>Cookies</h2>
                <p>
                  Cookies are small text files that may be placed and stored on
                  your computer/device allowing internet access when you visit
                  our websites.
                </p>
                <p>
                  We use cookies to collect your IP address and browsing
                  information. Our websites also remember your system and
                  preferences. Cookies are placed on your computer/device only
                  if you consent to it, unless cookies are necessary for
                  strictly technical functionality of our websites.
                </p>
                <p>
                  In order to record and analyze how visitors use our websites
                  as well as to improve visitors’ experience, we collects
                  details of your visits by using Google Analytics. Google
                  Analytics places and uses cookies that allow us to track
                  website traffic and users’ interaction with our websites.
                </p>
                <p>
                  We may use cookies to record your consents on our websites
                  (e.g. the consent to the use of cookies).
                </p>
                <p>
                  We use cookies on the basis of our legitimate interest in
                  ensuring the technical functionality of our websites. When we
                  use cookies to remember your choices or for analytics, the
                  legal basis for the use is your consent.
                </p>
                <p>
                  You can opt-out from analytics by disabling cookies through
                  your browser settings or by visiting&nbsp;
                  <a href="https://tools.google.com/dlpage/gaoptout/">
                    https://tools.google.com/dlpage/gaoptout/
                  </a>
                </p>
                <p>
                  If you want to disable other cookies, you can learn how to do
                  it by visiting&nbsp;
                  <a href="www.allaboutcookies.org">www.allaboutcookies.org</a>
                </p>
                <p>
                  Please note that if you disable or refuse cookies, our
                  websites or their parts may become inaccessible, not function
                  properly or you may not be able to use some of the interactive
                  features of our websites.
                </p>
                <h2>Who may access your personal data</h2>
                <p>
                  We may disclose your personal data to (1) our employees who
                  are in contact with you or who are responsible for marketing,
                  (2) our affiliated companies, (3) third-party service
                  providers.
                </p>
                <p>
                  Statistical data about our websites’ visitors may be accessed
                  by (1) our employees in marketing and/or IT departments who
                  are responsible for analyzing such data and for improving our
                  websites, (2) our affiliated companies (some of them are
                  located outside the European Union), (3) third-party service
                  providers.
                </p>

                <h2>Transfers to third countries</h2>
                <p>
                  We are a multinational group of companies. For this reason,
                  your personal data may be transferred to and stored outside
                  the country where you are located. This includes countries
                  outside the European Economic Area with no adequate level of
                  personal data protection (third countries).
                </p>
                <p>
                  As some of the countries where our offices are situated are
                  not yet recognized by the European Commission as countries
                  with an adequate level of personal data protection, these
                  offices have access to personal data on the basis of
                  instruments that cover the European Union requirements for the
                  transfer of personal data to data controllers/processors
                  outside the European Union (Standard Contractual Clauses
                  approved by the European Commission). You may ask us to
                  inspect copies of these clauses by contacting our data
                  protection officer.
                </p>
                <h2>Third-party providers</h2>
                <p>
                  When we transfer personal data, we do so for the purposes for
                  which the information has been collected/submitted, for the
                  purposes listed above, for the administration and maintenance
                  of our websites and associated systems, and/or other internal
                  or administrative purposes. We also may transfer personal data
                  to third parties providing identity management, website
                  hosting and management, data analysis, data backup, security
                  and storage services.
                </p>
                <p>
                  We work only with those third-party providers that are bound
                  to maintain appropriate levels of security and
                  confidentiality, to process personal data only as instructed
                  by us and to flow those same obligations down to their
                  sub-processors.
                </p>
                <h2>Retention of your personal data</h2>
                <p>
                  We will retain your personal information in our systems only
                  for as long as we need it, given the purposes for which it was
                  collected, or as required to do so by law.
                </p>

                <h2>Rights in relation to your personal data</h2>
                <p>
                  Under your local laws and the European Union legislation, you
                  may exercise the following rights by submitting your
                  request/inquiry on our websites:
                </p>
                <ul>
                  <li>right to require access to your personal data,</li>
                  <li>right to require rectification of your personal data,</li>
                  <li>right to require erasure of your personal data,</li>
                  <li>
                    right to withdraw your consent regarding processing of your
                    personal data.
                  </li>
                </ul>
                <p>
                  In some cases, you may also have a right (1) to request
                  restriction on processing of your personal data or (2) to
                  object to processing of your personal data.
                </p>
                <p>
                  There are cases when we can retain copies of the personal data
                  you requested us to erase. They concern the necessity to
                  protect legitimate interests of Technocrom or third parties,
                  comply with governmental orders, resolve disputes,
                  troubleshoot problems, or enforce any agreement you have
                  formed with us.
                </p>

                <h2>Right to lodge a complaint with a supervisory authority</h2>
                <p>
                  You have the right to lodge a complaint with your local data
                  protection regulator if you think your privacy rights have
                  been violated.
                </p>

                <h2>Contact us</h2>
                <p>
                  If you have any questions or comments regarding this Privacy
                  and Cookies Policy, you can contact us via the request/inquiry
                  form on this website.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PrivacyPolicy;
